import React from 'react';

interface FooterProps {
  complianceLine?: string;
}

const Footer: React.FC<FooterProps> = ({ complianceLine }) => {
  if (!complianceLine) {
    return null;
  }

  return (
    <div
      style={{
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 12,
        padding: '12px 0 8px',
      }}
    >
      {complianceLine}
    </div>
  );
};

export default Footer;
